import { Link } from "react-router-dom";
import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { formatAddress, useSettings } from "@/context/SettingsContext";

export const Footer = () => {
  const { settings } = useSettings();

  return (
    <footer className="bg-blue-950 text-slate-300 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5 space-y-4">
          <div className="flex items-center gap-3">
            <span className="grid place-items-center w-10 h-10 rounded-full bg-sky-500 text-white font-display">
              N
            </span>
            <span className="font-display text-2xl text-white">Nidaan Dental Care</span>
          </div>
          <p className="text-sm leading-relaxed max-w-sm text-slate-400">
            An independent neighbourhood dental clinic focused on painless treatment, honest advice and
            strict sterilization standards.
          </p>
        </div>

        <div className="md:col-span-3 space-y-3">
          <h4 className="text-white text-sm tracking-[0.16em] uppercase">Explore</h4>
          <ul className="space-y-2 text-sm">
            {[
              ["/", "Home"],
              ["/about", "About & Services"],
              ["/gallery", "Gallery"],
              ["/contact", "Visit Us"],
              ["/book", "Book Appointment"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link to={to} className="hover:text-sky-300 transition-colors duration-200">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4 space-y-4 text-sm">
          <h4 className="text-white text-sm tracking-[0.16em] uppercase">Reach Us</h4>
          <p className="flex gap-3" data-testid="footer-address">
            <MapPin className="w-4 h-4 mt-1 text-sky-400 shrink-0" />
            <span>{formatAddress(settings)}</span>
          </p>
          <p className="flex gap-3" data-testid="footer-phone">
            <Phone className="w-4 h-4 mt-0.5 text-sky-400 shrink-0" />
            <a href={`tel:${(settings.phone || "").replace(/\s/g, "")}`} className="hover:text-sky-300">
              {settings.phone}
            </a>
          </p>
          <p className="flex gap-3" data-testid="footer-email">
            <Mail className="w-4 h-4 mt-0.5 text-sky-400 shrink-0" />
            <span>{settings.email}</span>
          </p>
          <p className="flex gap-3" data-testid="footer-hours">
            <Clock className="w-4 h-4 mt-0.5 text-sky-400 shrink-0" />
            <span>
              {settings.hours_weekday}
              {settings.hours_weekend ? <><br />{settings.hours_weekend}</> : null}
            </span>
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Nidaan Dental Care · nidaandentalcare.co.in
      </div>
    </footer>
  );
};
